import { Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Admin } from '../../../services/admin';
import { User } from '../../../services/user';
import { DomSanitizer } from '@angular/platform-browser';
import { Location } from '@angular/common';

@Component({
  selector: 'app-view-uploaded-file',
  standalone: false,
  templateUrl: './view-uploaded-file.html',
  styleUrl: './view-uploaded-file.less'
})
export class ViewUploadedFile implements OnInit {
  pdfUrl:any;
  imgData:any;
  private adminService = inject(Admin);
  private userService = inject(User);
  private location = inject(Location);
  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private sanitizer: DomSanitizer,
    private _dialog:MatDialogRef<ViewUploadedFile>
  ){
    console.log(data);
  }

  ngOnInit(): void {
      this.getMediaById(this.data.id);
  }

  getMediaById(id:any){
    // this.imgData=this.data.photoPath;
    if(this.data.contentType && this.data.contentType.includes('image')){
      this.adminService.getMediaById(id).subscribe({
        next:(data:Blob)=>{
          this.imgData = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data));
        }
      })
    }else if (this.data.contentType=='application/pdf'){
        this.userService.getMediaById(this.data.id)
        .subscribe({
          next:(data:any)=>{
            let file = new Blob([data], { type: "application/pdf" });
            this.pdfUrl = URL.createObjectURL(file);
          },
          error: async (err: any) => {
            console.log("error");
            console.log(err);
            // this.loader.hideLoader();
          },
        })

    }
   
   }

   close(){
    this._dialog.close();
   }
}
